module.exports = __webpack_public_path__ + "static/media/Error.8e3b6ea0.svg";